import { render } from "./ChoixPortailClient.vue?vue&type=template&id=7422b27e&ts=true"
import script from "./ChoixPortailClient.vue?vue&type=script&lang=ts"
export * from "./ChoixPortailClient.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__